
// <![CDATA[
(function(window, undefined) {
    var snize_results = document.getElementById('snize_results');
    if (snize_results != null && snize_results != undefined && snize_results.innerHTML != '') {
      return;
    }
    sIntervalNew = setInterval(function() {
      var snize_results = document.getElementById('snize_results');
      if (snize_results != null && snize_results != undefined && snize_results.innerHTML != '') {
        clearInterval(sIntervalNew);
        var skeleton_results = document.getElementById('snize_skeleton_results');

        if (skeleton_results != null && skeleton_results != undefined) {
          if (skeleton_results.parentNode) {
            skeleton_results.parentNode.removeChild(skeleton_results);
          }
        }
        createImageBreaker();
        vendorTitle();
        callingAllTags();
        chooseOptions();
        setUpObserver();
        return;
      }
      var grid_wrapper = document.getElementById('snize-search-results-wrapper');
      if (grid_wrapper.offsetWidth >= 1055) {
          grid_wrapper.className = grid_wrapper.className.replace(/(?:^|\s)snize-three-columns(?!\S)/g , '').replace(/(?:^|\s)snize-four-columns(?!\S)/g , '');
          if (!grid_wrapper.className.match(/(?:^|\s)snize-five-columns(?!\S)/)) {
              grid_wrapper.className += ' snize-four-columns';
          }
      } else if (grid_wrapper.offsetWidth >= 915) {
          grid_wrapper.className = grid_wrapper.className.replace(/(?:^|\s)snize-three-columns(?!\S)/g , '').replace(/(?:^|\s)snize-five-columns(?!\S)/g , '');
          if (!grid_wrapper.className.match(/(?:^|\s)snize-four-columns(?!\S)/)) {
              grid_wrapper.className += ' snize-four-columns';
          }
      } else {
          grid_wrapper.className = grid_wrapper.className.replace(/(?:^|\s)snize-four-columns(?!\S)/g , '').replace(/(?:^|\s)snize-five-columns(?!\S)/g , '');
          if (!grid_wrapper.className.match(/(?:^|\s)snize-three-columns(?!\S)/)) {
              grid_wrapper.className += ' snize-three-columns';
          }
      }
    }, 30);

    function createImageBreaker() {
      // If search results page, don't try looking for image breakers
      if(window.location.href.indexOf("/pages/search-results") > -1) {
        return false;
      }

      // Otherwise, look away 👀
      const imageBreakerCheck = document.querySelector('.collection-image-breaker');
      if (imageBreakerCheck) { return; }

      const gridItem = document.querySelector('div.snize #snize-search-results-grid-mode li.snize-product:nth-of-type(7)');

      if (gridItem) {
        if(imageBreakerImage !== false) {
          gridItem.insertAdjacentHTML("afterend", imageBreakerImage);
        }
      }
    }

    function vendorTitle() {
      var variants = document.querySelectorAll('.snize-product');
      for (var i = 0; i < variants.length; i++) {
        /* Get Vendor Container */
        var vendor = variants[i].querySelector('.snize-attribute');
        /* Get the product title */
        var productTitle = variants[i].querySelector('.snize-title');
        if (productTitle != null && productTitle != undefined) {
          /* Create temp string for Product Title */
          var tempProductTitle = productTitle.innerHTML;
          /* Remove unused HTML */
          if(vendor.querySelector('.snize-attribute-title')) {
            vendor.querySelector('.snize-attribute-title').remove();
          }
          /* Remove whitespace from vendor string */
          var vendorTitle = vendor.innerHTML.trim();
          /* Remove Vendor from Product Title */
          if (tempProductTitle.includes(vendorTitle)) {
            tempProductTitle = tempProductTitle.replace(vendorTitle, ' ')
            /* Update Product Title inner HTML */
            productTitle.innerHTML = tempProductTitle;
          }
        }
      }
    }

    function chooseOptions() {
      var variants = document.querySelectorAll('.snize-product');
      for (var i = 0; i < variants.length; i++) {
        var currentVariant = variants[i];
        var options = currentVariant.querySelector('.snize-option-other');
        /* Get Vendor Container */

        if (options != null) {
          const selectorWrapper = currentVariant.querySelector('.snize-option-selector-wrapper');
          if (selectorWrapper != null) {
            if(selectorWrapper.classList.contains('snize-option-count-1')) {
              addToCartListener(currentVariant);
            } else {
              chooseOptionsButton(currentVariant)
            }
          } else {
            chooseOptionsButton(currentVariant)
          }
        } else {
          addToCartListener(currentVariant);
        }
      }
    }

    function addToCartListener(currentVariant) {
      var button = currentVariant.querySelector('.snize-button');

      if (button != null) {
        button.addEventListener('click', function() {
          var domain = "https://" + window.location.hostname;
          var parent = button.closest('.snize-product');

          var Name = parent.querySelector('.snize-title').innerText;
          var ProductId = parent.querySelector('.swym-add-to-wishlist-view-product').getAttribute('data-product-id');
          ProductId = parseInt(ProductId);
          var Categories = document.querySelector('.collection-hero__title').getAttribute('data-collection-title');
          var ImageUrl = parent.querySelector('.snize-item-image').getAttribute('src');
          var URL = domain + parent.querySelector('.snize-view-link').getAttribute('href');
          var Brand = parent.querySelector('.snize-attribute').innerText;
          var Price = parent.querySelector('.snize-price').innerText;
          Price = Price.replace('£', '');
          var CompareAtPrice = parent.querySelector('.snize-discounted-price')
          if(CompareAtPrice) {
            CompareAtPrice = CompareAtPrice.innerText;
            CompareAtPrice = CompareAtPrice.replace('£', '');
          } else {
            CompareAtPrice = "0.00";
          }

          var item = {
            "Added to Cart Value": Price,
            Name: Name,
            ProductID: ProductId,
            Categories: [Categories],
            ImageURL: ImageUrl,
            URL: URL,
            Brand: Brand,
            Price: Price,
            CompareAtPrice: CompareAtPrice
          };

          document.body.dispatchEvent(new CustomEvent('addToCart', { detail: item }));
        });
      }
    }

    function chooseOptionsButton(currentVariant) {
      var button = currentVariant.querySelector('.snize-button');
      button.innerHTML = 'Choose Options';
      button.outerHTML = '<div class="snize-button">Choose Options</div>';
    }

    /**
     * Add Worth sticker to .snize-product items that have the class starting with 'snize-product-tag-worth_value'
     * This class is added to the product in via tags from Searchanise
     */
    function createTags(tagName, stickerText, ignoreFreeGift) {
      var cardsTags = document.querySelectorAll(`[class*="${tagName}"]`);
      for (var i = 0; i < cardsTags.length; i++) {
        const classList = cardsTags[i].classList;
        const hasSticker = cardsTags[i].querySelector('sticker');
        let continueLoop = true;
        if (ignoreFreeGift != null) {
          ignoreFreeGift.forEach(element => {
            classList.forEach(classItem => {
              if (classItem.toLowerCase().includes(element.toLowerCase())) {
                continueLoop = false;
              }
            });
          });
        }

        if (hasSticker != null) { return; }

        for (var j = 0; j < classList.length; j++) {

          if (continueLoop == true) {
            if (classList[j].includes(tagName)) {
              const tagValue = classList[j].replace(tagName, '');
              let sticker = stickerText;
              if (stickerText.includes('--replace--')) {
                sticker = stickerText.replace('--replace--', tagValue);
              }
              const tag = document.createElement('div');
              tag.innerHTML = sticker;
              cardsTags[i].appendChild(tag);
            }
          }
        }
      }
    }


    function callingAllTags() {
      const ignoreFreeGift = ['snize-product-tag-worth_value','snize-product-tag-sale_badge'];
      const ignoreAll = ['snize-product-tag-worth_value','snize-product-tag-sale_badge', 'snize-product-tag-free_gift'];
      const tagNameWorth = 'snize-product-tag-worth_value';
      const stickerWorth = `<span class="sticker sticker--small"><span>WORTH <strong>£--replace--</strong></span></span>`;

      const tagSaleBadge = 'snize-product-tag-sale_badge';
      const stickerSale = `<span class="sticker sticker--small sticker--tertiary"><strong>Sale</strong></span>`;

      const tagNameFreeGift = 'snize-product-tag-free_gift';
      const stickerFreeGift = `<span class="sticker sticker--free-gift sticker--small sticker--square">Free Gift</span>`;

      const tagNameOOS = 'snize-product-out-of-stock';
      const stickerOOS = `<span class="sticker sticker--OOS sticker--small sticker--square">Sold Out</span>`;

      createTags(tagNameWorth, stickerWorth)
      createTags(tagSaleBadge, stickerSale)
      createTags(tagNameFreeGift, stickerFreeGift, ignoreFreeGift)
      createTags(tagNameOOS, stickerOOS, ignoreAll)
    }

    if (window.location.href.indexOf('collection=') != -1) {
        var elements = document.getElementsByClassName('snize-search-results-page-title');
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.display = 'none';
        }
    }

    /**
     * This observer is used to detect when the user interacts with the filters or show more
     */
    function setUpObserver() {
      // Select the node that will be observed for mutations
      const targetNode = document.getElementById('snize_results');

      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };

      // Callback function to execute when mutations are observed
      const callback = (mutationList, observer) => {
        // Once run, disconnect the observer
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            // console.log('A child node has been added or removed.');
            observer.disconnect();
            processTitles()
            processImages()
            processTags()
            processChooseOptions()
          }
        }
        // Reconnect the observer after 0.6 second
        setTimeout(() => {
          observer.observe(targetNode, config);
        }, 1600);

      };

      /**
       * Debounce function limits the number of times a function can be called in a given time
       */
      function debounce(func, timeout = 300){
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
      }

      const processTitles = debounce(() => vendorTitle());
      const processImages = debounce(() => createImageBreaker());
      const processTags = debounce(() => callingAllTags());
      const processChooseOptions = debounce(() => chooseOptions());

      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
      console.log('Observer: I am watching the results');
    }
})(window);
// ]]>
